import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mq = "@media screen and (".concat(componentTheme.phoneBreakPoint, ")");
  return {
    itemAnalysisRow: {
      padding: componentTheme.itemAnalysisRowPadding,
      marginBottom: componentTheme.itemAnalysisRowMargin,
      position: 'relative'
    },
    headerRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start'
    },
    headerText: {
      color: componentTheme.headerTextColor,
      fontSize: componentTheme.headerTextFontSize
    },
    metricsRow: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      paddingBottom: componentTheme.metricsRowLowerPadding
    },
    metricNote: {
      fontSize: componentTheme.metricNoteFontSize,
      color: componentTheme.metricNoteColor
    },
    stem: {
      flex: '1 0 35%',
      fontSize: componentTheme.stemFontSize,
      lineHeight: componentTheme.stemLineHeight,
      marginBottom: componentTheme.stemMargin,
      '& p': {
        margin: 0
      }
    },
    metrics: {
      flex: '0 1 42rem'
    },
    metric: _defineProperty({
      justifyContent: 'center'
    }, mq, {
      flexBasis: '50%'
    }),
    emptyText: {
      flex: '0 1 42rem',
      padding: componentTheme.emptyTextPadding,
      textAlign: 'center',
      color: componentTheme.emptyTextColor
    },
    answerAnalysis: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      margin: '0 -1rem'
    },
    answerTableSection: {
      /* Explicit flex-basis is a workaround for https://bugs.webkit.org/show_bug.cgi?id=136041 */
      flex: '10 1 45%'
    },
    answerDistributionSection: {
      flex: '1 1 auto',
      /* Non-zero width for IE11 flex-wrap */
      minWidth: '1%'
    },
    answerDistribution: _defineProperty({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
      padding: "0 ".concat(componentTheme.answerDistributionPadding),
      position: 'relative'
    }, mq, {
      padding: 0
    }),
    answerDistributionChart: {
      width: '19rem',
      padding: "0 ".concat(componentTheme.answerDistributionChartPadding)
    },
    answerDistributionLegend: {
      padding: "0 ".concat(componentTheme.answerDistributionLegendPadding)
    },
    answerDistributionSwatch: {
      backgroundColor: componentTheme.answerDistributionSwatchColor
    },
    outcomeAlignments: {
      display: 'flex',
      margin: '0 - 1rem'
    }
  };
};
export default generateStyle;